import { Page } from '@shared/interfaces/Pages'
import styled from 'styled-components'

const Container = styled.li`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;

  @media (min-width: 992px) {
    width: 25%;
    margin-right: 50px;
    &:last-child {
      margin-right: 0;
    }
  }
`

const Wrapper = styled.div<{ $page: Page }>`
  display: flex;
  flex-direction: ${props => props.$page === 'home' ? 'row' : 'column'};
  align-items: ${props => props.$page === 'home' ? 'center' : 'flex-start'};
  gap: ${props => props.$page === 'home' ? '21px' : '0'};
  margin-bottom: ${props => props.$page === 'curadoria' || props.$page === 'ineditos' ? '8px' : '0'};
  @media (min-width: 992px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    margin-bottom: 8px;
  }
  `

const Image = styled.img`
  margin-bottom: 16px;
  max-height: 64px;

  @media (min-width: 992px) {
    max-height: 80px;
  }`

const Title = styled.div`
  @media (min-width: 992px) {
    display: flex;
    align-items: center;
  }
`

const SecondaryText = styled.p`
  font-family: 'Noto Sans', sans-serif;
  font-size: 14px;
  color: #343A4F;
  line-height: 20px;
`

export { Wrapper, Image, Title, SecondaryText, Container }
